'use client';

import { useEffect, useState } from 'react';

interface PricingTransparencyProps {
  language: 'en' | 'es';
}

const PricingTransparency = ({ language }: PricingTransparencyProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.1 }
    );

    const element = document.getElementById('pricing-transparency');
    if (element) observer.observe(element);

    return () => observer.disconnect();
  }, []);

  const content = {
    en: 'Our fees are fixed for most services. No surprises.',
    es: 'Nuestros honorarios son fijos para la mayoría de servicios. Sin sorpresas.',
  };

  return (
    <section id="pricing-transparency" className="py-20 px-6 bg-muted">
      <div className="max-w-screen-xl mx-auto">
        <div
          className={`p-8 bg-background border hairline border-border sharp text-center ${
            isVisible ? 'animate-fadeInScale' : 'opacity-0'
          }`}
        >
          <p className="text-2xl font-bold text-foreground">
            {content[language]}
          </p>
        </div>
      </div>
    </section>
  );
};

export default PricingTransparency;